"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EthereumWalletRegistry = void 0;
const contracts_1 = require("../contracts");
const utils_1 = require("../utils");
const ethers_1 = require("ethers");
const adapter_1 = require("./adapter");
const address_1 = require("./address");
const WalletRegistry_json_1 = __importDefault(require("./artifacts/mainnet/WalletRegistry.json"));
const WalletRegistry_json_2 = __importDefault(require("./artifacts/sepolia/WalletRegistry.json"));
const WalletRegistry_json_3 = __importDefault(require("@keep-network/ecdsa/artifacts/WalletRegistry.json"));
/**
 * Implementation of the Ethereum WalletRegistry handle.
 * @see {WalletRegistry} for reference.
 */
class EthereumWalletRegistry extends adapter_1.EthersContractHandle {
    constructor(config, chainId = contracts_1.Chains.Ethereum.Local) {
        let deployment;
        switch (chainId) {
            case contracts_1.Chains.Ethereum.Local:
                deployment = WalletRegistry_json_3.default;
                break;
            case contracts_1.Chains.Ethereum.Sepolia:
                deployment = WalletRegistry_json_2.default;
                break;
            case contracts_1.Chains.Ethereum.Mainnet:
                deployment = WalletRegistry_json_1.default;
                break;
            default:
                throw new Error("Unsupported deployment type");
        }
        super(config, deployment);
    }
    // eslint-disable-next-line valid-jsdoc
    /**
     * @see {WalletRegistry#getChainIdentifier}
     */
    getChainIdentifier() {
        return address_1.EthereumAddress.from(this._instance.address);
    }
    // eslint-disable-next-line valid-jsdoc
    /**
     * @see {WalletRegistry#getWalletPublicKey}
     */
    async getWalletPublicKey(walletID) {
        const publicKey = await (0, utils_1.backoffRetrier)(this._totalRetryAttempts)(async () => {
            return await this._instance.getWalletPublicKey(walletID.toPrefixedString());
        });
        return utils_1.Hex.from(publicKey.substring(2));
    }
    // eslint-disable-next-line valid-jsdoc
    /**
     * @see {WalletRegistry#getDkgResultSubmittedEvents}
     */
    async getDkgResultSubmittedEvents(options, ...filterArgs) {
        const events = await this.getEvents("DkgResultSubmitted", options, ...filterArgs);
        return events.map((event) => {
            return {
                blockNumber: ethers_1.BigNumber.from(event.blockNumber).toNumber(),
                blockHash: utils_1.Hex.from(event.blockHash),
                transactionHash: utils_1.Hex.from(event.transactionHash),
                resultHash: utils_1.Hex.from(event.args.resultHash),
                seed: utils_1.Hex.from(ethers_1.BigNumber.from(event.args.seed).toHexString()),
                result: {
                    submitterMemberIndex: ethers_1.BigNumber.from(event.args.result.submitterMemberIndex),
                    groupPubKey: utils_1.Hex.from(event.args.result.groupPubKey),
                    misbehavedMembersIndices: event.args.result.misbehavedMembersIndices.map((mmi) => ethers_1.BigNumber.from(mmi).toNumber()),
                    signatures: utils_1.Hex.from(event.args.result.signatures),
                    signingMembersIndices: event.args.result.signingMembersIndices.map(ethers_1.BigNumber.from),
                    members: event.args.result.members.map((m) => ethers_1.BigNumber.from(m).toNumber()),
                    membersHash: utils_1.Hex.from(event.args.result.membersHash),
                },
            };
        });
    }
    // eslint-disable-next-line valid-jsdoc
    /**
     * @see {WalletRegistry#getDkgResultApprovedEvents}
     */
    async getDkgResultApprovedEvents(options, ...filterArgs) {
        const events = await this.getEvents("DkgResultApproved", options, ...filterArgs);
        return events.map((event) => {
            return {
                blockNumber: ethers_1.BigNumber.from(event.blockNumber).toNumber(),
                blockHash: utils_1.Hex.from(event.blockHash),
                transactionHash: utils_1.Hex.from(event.transactionHash),
                resultHash: utils_1.Hex.from(event.args.resultHash),
                approver: address_1.EthereumAddress.from(event.args.approver),
            };
        });
    }
    // eslint-disable-next-line valid-jsdoc
    /**
     * @see {WalletRegistry#getDkgResultChallengedEvents}
     */
    async getDkgResultChallengedEvents(options, ...filterArgs) {
        const events = await this.getEvents("DkgResultChallenged", options, ...filterArgs);
        return events.map((event) => {
            return {
                blockNumber: ethers_1.BigNumber.from(event.blockNumber).toNumber(),
                blockHash: utils_1.Hex.from(event.blockHash),
                transactionHash: utils_1.Hex.from(event.transactionHash),
                resultHash: utils_1.Hex.from(event.args.resultHash),
                challenger: address_1.EthereumAddress.from(event.args.challenger),
                reason: event.args.reason,
            };
        });
    }
}
exports.EthereumWalletRegistry = EthereumWalletRegistry;
//# sourceMappingURL=wallet-registry.js.map